export default __webpack_public_path__ + "static/GT-America-Extended-Bold-Italic-6d790c68999e33e2128b7a22c1aa33ce.ttf";